// extracted by mini-css-extract-plugin
export var deliveryRow = "_ru-a";
export var fixedHeight = "_ru-4";
export var freightLogo = "_ru-9";
export var fullWidth = "_ru-3";
export var priceColumn = "_ru-5";
export var radioSelected = "_ru-7";
export var radioUnselected = "_ru-6";
export var selectedOption = "_ru-2";
export var selectedOptionContainer = "_ru-1";
export var selection = "_ru-0";
export var tallSkeletonText = "_ru-8";